//@flow
import * as React from 'react'
import type { AthenaQualityReview$Props } from './flowTypes'
import ContainerRowExpandPanel from '../../components/common/ContainerRowExpandPanel'
import QualityReviewContainer from '../../components/QualityReview/QualityReviewContainer'

const AthenaQualityReview=(props:AthenaQualityReview$Props)=>{
    const athena = props.athena
    let isVisible = false

    if (athena.reviewQuestions && athena.reviewQuestions.length > 0){
        isVisible = true
    }
    
    return (
        <ContainerRowExpandPanel visible={isVisible} 
        title={'Final Review Before Submission'} elementId={'athenaQualityReview'} 
        errors={props.noOfErros}
        >
            <QualityReviewContainer 
                elementId={'athenaPanelReviewQuestion'} 
                changeFieldValue={props.changeFieldValue} 
                questions={(athena.reviewQuestions:any)} 
            />
        </ContainerRowExpandPanel>
    )
}

export default AthenaQualityReview


// WEBPACK FOOTER //
// ./src/views/projectAthena/AthenaQualityReview.js